var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-internet-alert"},[_c('icon-no-internet',{staticClass:"icon",attrs:{"width":"50","height":"50","iconColor":"#3e3a3b"}}),_c('div',[_vm._v("\n    "+_vm._s(_vm.$t("noInternetConnection"))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }